<template>
  <div>
    <div v-if="mode === 'DESIGN'" class="max-width" >
      <el-input  size="small" class="disabled-box" :placeholder="placeholder" suffix-icon="el-icon-date"></el-input>
      <!-- <el-date-picker size="small" class="disabled-box" :type="type" :placeholder="placeholder" suffix-icon="el-icon-date"></el-date-picker> -->
    </div>
    <div v-else>
      <div v-if="!readerMode || perm==='E'" class="my-date-picker" >
        <el-date-picker v-model="_value" :value-format="format" size="small" :type="type" :disabled="perm==='R'" :placeholder="placeholder" clearable prefix-icon="el-icon-date"  :picker-options="pickerOptions"></el-date-picker>
      </div>
      <!-- <el-date-picker v-else  v-model="_value" :value-format="format" size="small" clearable :type="type" :placeholder="placeholder" disabled prefix-icon="el-icon-date"></el-date-picker> -->
      <div v-else class="form-item-text">{{ value }}</div>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "DateTime",
  components: {},
  props:{
    value: {
      default: null
    },
    format:{
      type: String,
      default: 'yyyy-MM-dd'
    },
    placeholder:{
      type: String,
      default: '请选择'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
    labelTitle: {
      type: String,
      default: ''
    }
  },
  computed:{
    type(){
      switch (this.format){
        // case 'yyyy': return 'year';
        // case 'yyyy-MM': return 'month';
        case 'yyyy-MM-dd': return 'date';
        case 'yyyy-MM-dd HH:mm:ss': return 'datetime';
        default: return 'datetime';
      }
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          if (this.labelTitle && this.labelTitle === '补卡时间') {
            // 禁用今天之后的日期（今天可选）
            return time.getTime() > Date.now()
          }
          return false
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.max-width{
  max-width: 208px;
}
.my-date-picker {
  position: relative;
  line-height: 1;
  display: inline-block;
  /deep/{
    .el-input__inner{
      padding: 0 30px 0 8px;
      }
      .el-input{
        width: 100%;
      }
    .el-input__prefix{
      left: inherit;
      right: 5px;
    }
    .el-input__suffix{
      right: 25px;
      transition: none;
    }
  }
}
// .w-220{
//     // width: 220px;
//     width: 100%;
//    max-width: 220px;
// }

// /deep/.el-range-editor--small.el-input__inner{
//   width: 195px;
// }
</style>
